import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconBullhorn = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconBullhorn.dimensions.width} ${IconBullhorn.dimensions.height}`}
      {...otherProps}
    >
      <G fill={color || Color.premiumBlack} fillRule="nonzero">
        <Path d="M22.809.282a1.15 1.15 0 011.885.887v15.59c0 .48-.298.908-.747 1.075-.408.152-.863.06-1.162-.213l-.334-.336a12.037 12.037 0 00-8.514-3.399H3.866A1.359 1.359 0 012.51 12.53l-.001-.568h.011V5.328a1.36 1.36 0 011.357-1.356h9.745A11.939 11.939 0 0022.458.627l.249-.249.102-.095zM3.654 12.594a.224.224 0 00.213.158l10.437.001a13.183 13.183 0 019.231 4.015c.004.004.01.006.016.004a.014.014 0 00.009-.013V1.166a.016.016 0 00-.028-.011l-.272.273a13.055 13.055 0 01-9.663 3.678H3.878c-.123 0-.224.1-.224.223v7.265z" />
        <Path d="M3.644 5.222v7.354H1.475A1.48 1.48 0 010 11.099V6.697a1.48 1.48 0 011.477-1.475h2.167zM2.51 6.356H1.479a.346.346 0 00-.345.343v4.398c0 .19.155.344.343.345H2.51V6.356zM9.714 19.988a1.895 1.895 0 01-1.887 1.898h-.79a1.896 1.896 0 01-1.897-1.897v-7.237h4.574v7.236zm-3.44-6.102v6.103a.762.762 0 00.763.763h.787a.76.76 0 00.756-.763v-6.103H6.274zM24.357 12.296c1.348 0 2.317-1.52 2.317-3.307 0-1.782-.976-3.307-2.317-3.307a.567.567 0 00-.092 1.127l.092.007c.582 0 1.183.94 1.183 2.173 0 1.177-.537 2.079-1.095 2.166l-.088.007a.567.567 0 100 1.134z" />
      </G>
    </Svg>
  )
}

IconBullhorn.dimensions = {
  width: 27,
  height: 22,
}

export default IconBullhorn
